import { motion, AnimatePresence } from "framer-motion";

const formatNames = (names) => {
  if (names.length === 0) return "";
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;

  return `${names[0]}, ${names[1]}, +${names.length - 2}`;
};

const buildCopy = (viewers) => {
  if (viewers.length === 0) return null;

  const typing = viewers.filter((v) => v.isTyping);
  const justViewing = viewers.filter((v) => !v.isTyping);

  if (typing.length > 0 && justViewing.length === 0) {
    const verb = typing.length === 1 ? "is" : "are";

    return `${formatNames(typing.map((v) => v.name))} ${verb} replying`;
  }

  if (typing.length > 0 && justViewing.length > 0) {
    const typingVerb = typing.length === 1 ? "is" : "are";
    const viewingVerb = justViewing.length === 1 ? "is" : "are";

    return `${formatNames(typing.map((v) => v.name))} ${typingVerb} replying (${formatNames(
      justViewing.map((v) => v.name)
    )} ${viewingVerb} also viewing)`;
  }

  const verb = viewers.length === 1 ? "is" : "are";

  return `${formatNames(viewers.map((v) => v.name))} ${verb} also viewing this ticket`;
};

const TicketPresenceBanner = ({ viewers }) => {
  const copy = buildCopy(viewers);
  const isAnyTyping = viewers.some((v) => v.isTyping);

  return (
    <AnimatePresence>
      {copy && (
        <motion.div
          animate={{ opacity: 1, height: "auto" }}
          aria-live="polite"
          className="flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-4 py-2 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-800/60 dark:text-gray-300"
          exit={{ opacity: 0, height: 0 }}
          initial={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.2 }}
        >
          <span
            aria-hidden
            className={`inline-block h-2 w-2 rounded-full ${
              isAnyTyping ? "animate-pulse bg-amber-500" : "bg-emerald-500"
            }`}
          />
          <span>
            {copy}
            {isAnyTyping && (
              <span aria-hidden className="ml-1 inline-flex gap-0.5">
                <span
                  className="inline-block h-1 w-1 animate-bounce rounded-full bg-current"
                  style={{ animationDelay: "0ms" }}
                />
                <span
                  className="inline-block h-1 w-1 animate-bounce rounded-full bg-current"
                  style={{ animationDelay: "150ms" }}
                />
                <span
                  className="inline-block h-1 w-1 animate-bounce rounded-full bg-current"
                  style={{ animationDelay: "300ms" }}
                />
              </span>
            )}
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TicketPresenceBanner;
